import {Validators} from "@angular/forms";
import {MetricDescriptor} from "./quick-forecast.models";
import {EarningBaseCode} from "../../../../../shared/model/earning-base-code";

const PERCENT_FIRST_YEAR_RANGE = [Validators.min(-100), Validators.max(9999.99)];
const PERCENT_YOY_RANGE = [Validators.min(-999.9), Validators.max(9999.99)];
const MULTIPLE_FIRST_YEAR_RANGE = [Validators.min(0), Validators.max(9999.99)];

const PERCENT_SUFFIX = () => "%" as const;

export const METRICS: readonly MetricDescriptor[] = [
    {
        key: "revenueGrowth",
        label: () => "Revenue Growth",
        firstYearSuffix: "%",
        yoySuffix: PERCENT_SUFFIX,
        firstYearValidators: PERCENT_FIRST_YEAR_RANGE,
        yoyValidators: PERCENT_YOY_RANGE
    },
    {
        key: "margin",
        label: (earningBase) => `${earningBase} Margin`,
        firstYearSuffix: "%",
        yoySuffix: PERCENT_SUFFIX,
        firstYearValidators: PERCENT_FIRST_YEAR_RANGE,
        yoyValidators: PERCENT_YOY_RANGE
    },
    {
        key: "evOverEarningBase",
        // EBT has no EV multiple in the DTO — the FOV table re-uses
        // priceOverEarningsMultiple (P/E) for that case, and we mirror that.
        label: (earningBase) => earningBase === EarningBaseCode.EBT ? "P/E" : `EV / ${earningBase}`,
        firstYearSuffix: "x",
        yoySuffix: (mode) => mode === "ADDITIVE" ? "x" : "%",
        firstYearValidators: MULTIPLE_FIRST_YEAR_RANGE,
        yoyValidators: PERCENT_YOY_RANGE
    },
    {
        key: "debtRepaymentCapacity",
        label: () => "Debt Rep. Capacity",
        firstYearSuffix: "%",
        yoySuffix: PERCENT_SUFFIX,
        firstYearValidators: PERCENT_FIRST_YEAR_RANGE,
        yoyValidators: PERCENT_YOY_RANGE
    }
];
